import React from 'react'
import CommonModal from '../../UiKits/Modals/common/modal'
import { H5, P } from '../../../AbstractElements'
import { Descriptions } from 'antd'
import { useLocation } from 'react-router';
import { removeSearchParams } from '../../../utils';

const BugDetails = ({ bug, setBug }) => {
  const location = useLocation();

  const closeBug = () => {
    removeSearchParams(location);
    setBug({ show: false, details: null });
  };

  return (
    <div>
      <CommonModal
        isOpen={bug.show}
        toggler={() => closeBug()}
        showCloseBtn={true}
        successText={'Close'}
        title='Bug Reports'
        success={() => closeBug()}
        // disabled={loading}
        bodyClass='full-screen-modal'
        size="lg"
      >
        <Descriptions bordered column={1}>
          <Descriptions.Item label={<span>Email</span>}>
            <span>{bug.details?.email ?? 'Without Login'}</span>
          </Descriptions.Item>
          <Descriptions.Item label={<span>Description</span>}>
            <span>{bug.details?.errorMessage}</span>
          </Descriptions.Item>
          <Descriptions.Item label={<span>Browser Name</span>}>
            <span>{bug.details?.browserName}</span>
          </Descriptions.Item>
          <Descriptions.Item label={<span>OS Name</span>}>
            <span>{bug.details?.osName}</span>
          </Descriptions.Item>
          <Descriptions.Item label={<span>{bug.details.params.bugScreenShot ? 'Screesnhot' : "Params Data"}</span>}>
            <div>
              {bug.details.params.bugScreenShot ? (
                <div>
                  <img
                    src={bug.details.params.bugScreenShot}
                    height='100%'
                    width='100%'
                  />
                </div>
              ) : (
                <>
                  <P><b> Function Name:</b>{" "} {bug.details.functionName}</P>
                  <H5 >
                    Params Data:
                  </H5>
                  <p className="">
                    {bug.details.params.result ? (
                      <>
                        <P><b> category: </b> {" "}
                          {
                            bug.details.params.result[
                              bug.details.params.result.length - 1
                            ].category}</P>

                        <P><b>marks:</b> {" "}  {bug.details.params.result[
                          bug.details.params.result.length - 1
                        ].marks?.toFixed(2)} </P>
                        <P> <b> quiz name:</b> {" "} {
                          bug.details.params.result[
                            bug.details.params.result.length - 1
                          ].name
                        } </P>
                        <P><b>questions: </b> {' '}  {
                          bug.details.params.result[
                            bug.details.params.result.length - 1
                          ].progress?.questions.length
                        } </P>
                      </>
                    ) : (
                      Object.entries(bug.details.params).map(([key, value]) => (
                        <P

                          key={key}
                        >
                          {key} : {value}
                        </P>
                      ))
                    )}
                  </p>
                </>
              )}
            </div>
          </Descriptions.Item>
        </Descriptions>
      </CommonModal>
    </div>
  )
}

export default BugDetails